(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miscelia-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-ms-product]');
  if (!root) return;

  const mainImage = root.querySelector('[data-ms-main-image]');
  root.querySelectorAll('[data-ms-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (mainImage && thumb.dataset.src) mainImage.src = thumb.dataset.src;
      root.querySelectorAll('[data-ms-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const qty = root.querySelector('[data-ms-quantity]');
  root.querySelector('[data-ms-minus]')?.addEventListener('click', () => {
    qty.value = Math.max(1, Number(qty.value || 1) - 1);
  });
  root.querySelector('[data-ms-plus]')?.addEventListener('click', () => {
    qty.value = Math.min(99, Number(qty.value || 1) + 1);
  });

  const variantsScript = root.querySelector('[data-ms-variants]');
  if (!variantsScript) return;

  const variants = JSON.parse(variantsScript.textContent || '[]');
  const picker = root.querySelector('[data-ms-options]');
  const idInput = root.querySelector('[data-ms-variant-id]');
  const price = root.querySelector('[data-ms-price]');
  const compare = root.querySelector('[data-ms-compare]');
  const discount = root.querySelector('[data-ms-discount]');
  const submit = root.querySelector('[data-ms-submit]');
  const variantTitle = root.querySelector('[data-ms-variant-title]');

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'es', {
    style:'currency',
    currency:'{{ cart.currency.iso_code | default: shop.currency }}'
  }).format(cents / 100);

  const update = () => {
    const selected = Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => {
      return fieldset.querySelector('input:checked')?.value || '';
    });

    const variant = variants.find((v) => selected.every((value, index) => v.options[index] === value));
    if (!variant) return;

    idInput.value = variant.id;
    price.textContent = money(variant.price);
    if (variantTitle) variantTitle.textContent = variant.title;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compare.hidden = false;
      compare.textContent = money(variant.compare_at_price);
      discount.hidden = false;
      discount.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
    } else {
      compare.hidden = true;
      discount.hidden = true;
    }

    const canOrder = Boolean(variant.available);
    submit.disabled = !canOrder;
    submit.textContent = canOrder ? 'Agregar al carrito' : 'No disponible para compra ahora';

    if (variant.featured_image && mainImage) mainImage.src = variant.featured_image.src;
  };

  picker.addEventListener('change', update);
});

  } catch(e) { console.error(e); }
})();
})();
